import { gql, useQuery } from '@apollo/client'
import { formatDate } from 'helpers/string'
import { BiogradResultsQuery } from './__generated__/BiogradResultsQuery'

const biogradResultsQuery = gql`
  query BiogradResultsQuery {
    biogradResults {
      id
      filename
      status
      rowsProcessed
      error
      uploadedAt
      versionCount
    }
  }
`

const BiogradResults = () => {
  const { loading, error, data } = useQuery<BiogradResultsQuery>(biogradResultsQuery)

  if (error) {
    throw error
  }

  if (loading) {
    return <p>Loading...</p>
  }

  return (
    <>
      <table className="table is-bordered is-fullwidth">
        <thead>
          <th>Date received</th>
          <th>Filename</th>
          <th>Status</th>
          <th>Rows handled</th>
        </thead>
        <tbody>
          {data.biogradResults.map((result) => (
            <tr key={result.id}>
              <td>{formatDate(result.uploadedAt)}</td>
              <td>
                {result.filename}{' '}
                {result.versionCount > 1 && <span className="has-text-danger">({result.versionCount} versions)</span>}
              </td>
              <td>
                {result.status}
                {result.error && (
                  <>
                    <br />
                    {result.error}
                  </>
                )}
              </td>
              <td>{result.rowsProcessed}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

export default BiogradResults
